












































import { toRef, computed, defineComponent } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import userAddressesGetters from '~/modules/customer/getters/userAddressesGetters';
import type { TransformedCustomerAddress } from '~/modules/customer/composables/types';

export default defineComponent({
  name: 'UserAddressDetails',
  props: {
    address: {
      type: Object as PropType<TransformedCustomerAddress>,
      required: true,
    },
  },
  setup(props) {
    const address = toRef(props, 'address');

    const userAddress = computed(() => ({
      firstName: userAddressesGetters.getFirstName(address.value),
      lastName: userAddressesGetters.getLastName(address.value),
      street: userAddressesGetters.getStreetName(address.value),
      streetNumber: userAddressesGetters.getApartmentNumber(address.value),
      postalCode: userAddressesGetters.getPostCode(address.value),
      city: userAddressesGetters.getCity(address.value),
      province: userAddressesGetters.getProvince(address.value) || '',
      country: userAddressesGetters.getCountry(address.value),
      phone: userAddressesGetters.getPhone(address.value),
      isDefault: userAddressesGetters.isDefault(address.value),
      isDefaultShipping: userAddressesGetters.isDefaultShipping(address.value),
      isDefaultBilling: userAddressesGetters.isDefaultBilling(address.value),
    }));

    const isDefaultShippingText = computed(() => (userAddress.value.isDefaultShipping ? 'Default Shipping Address' : ''));

    const isDefaultBillingText = computed(() => (userAddress.value.isDefaultBilling ? 'Default Billing Address' : ''));

    return {
      userAddress,
      isDefaultShippingText,
      isDefaultBillingText,
    };
  },
});
